// Quick add for Paste Match (product page) and Finish Your Scheme: adds a variant and opens the bag drawer.
if (!customElements.get('scheme-add')) {
  customElements.define('scheme-add', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return; this.bound = true;
      // delegated: the element can be connected before its buttons are parsed, so never query them here
      this.addEventListener('click', (e) => { const b = e.target.closest('[data-scheme-add]'); if (b) this.add(e, b); });
      this.addEventListener('change', (e) => e.stopPropagation());
    }
    async add(e, btn) {
      e.preventDefault();
      btn = btn || e.currentTarget;
      const err = this.querySelector('[data-scheme-error]');
      const picker = this.querySelector('[data-scheme-variant]');
      const id = Number(btn.dataset.variant || picker?.value);
      if (!id) return;
      btn.disabled = true; if (err) err.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], ...(drawer ? { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname } : {}) }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
        const label = btn.textContent; btn.textContent = 'Added'; setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2000);
        if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        else window.location.href = '/cart';
      } catch (x) {
        btn.disabled = false; if (err) { err.textContent = x.message; err.hidden = false; }
      }
    }
  });
}
